import { useTranslation } from "react-i18next";
import { SubTitle, Text } from "../../common/texts";
import {
  Wrapper,
  Inner,
  TextCol,
  ImageCol,
} from "./contributingSection.styles";
import img from "../../../assets/images/snakes/contributing.jpeg";

export const ContributingSection = () => {
  const { t } = useTranslation("home");
  return (
    <Wrapper>
      <Inner>
        <TextCol>
          <SubTitle $bold>{t("contributing.title")}</SubTitle>
          <Text>{t("contributing.description")}</Text>
        </TextCol>
        <ImageCol>
          <img src={img} alt="contributing" />
        </ImageCol>
      </Inner>
    </Wrapper>
  );
};
